import { render, staticRenderFns } from "./ActionDetailsPage.vue?vue&type=template&id=c3ed1582&scoped=true&lang=html&"
import script from "./ActionDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ActionDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ActionDetailsPage.vue?vue&type=style&index=0&id=c3ed1582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ed1582",
  null
  
)

export default component.exports